var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.62436 7.98059H17.7502",
    stroke: "#000929",
    strokeOpacity: 0.7,
    strokeWidth: 1.69725,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9531 11.295H13.9609",
    stroke: "#000929",
    strokeOpacity: 0.7,
    strokeWidth: 1.69725,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1873 11.295H10.1951",
    stroke: "#000929",
    strokeOpacity: 0.7,
    strokeWidth: 1.69725,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41363 11.295H6.42149",
    stroke: "#000929",
    strokeOpacity: 0.7,
    strokeWidth: 1.69725,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9531 14.5931H13.9609",
    stroke: "#000929",
    strokeOpacity: 0.7,
    strokeWidth: 1.69725,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1873 14.5931H10.1951",
    stroke: "#000929",
    strokeOpacity: 0.7,
    strokeWidth: 1.69725,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41363 14.5931H6.42149",
    stroke: "#000929",
    strokeOpacity: 0.7,
    strokeWidth: 1.69725,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6152 1.69727V4.48991",
    stroke: "#000929",
    strokeOpacity: 0.7,
    strokeWidth: 1.69725,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75984 1.69727V4.48991",
    stroke: "#000929",
    strokeOpacity: 0.7,
    strokeWidth: 1.69725,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7802 3.03735H6.59461C4.10245 3.03735 2.54584 4.42565 2.54584 6.97755V14.6573C2.54584 17.2494 4.10245 18.6697 6.59461 18.6697H13.7723C16.2723 18.6697 17.8211 17.2734 17.8211 14.7215V6.97755C17.829 4.42565 16.2802 3.03735 13.7802 3.03735Z",
    stroke: "#000929",
    strokeOpacity: 0.7,
    strokeWidth: 1.69725,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.8f5ce0fa3a1e39a94760c859e490c8a1.svg";
export { ForwardRef as ReactComponent };